import { DOMHelper } from "../Helpers/DOMHelper.js";

export class AdobeDtmDatalayer {

    constructor(app) {
        this.app = app;
        this.enabled = false;
        this.providerName ='pixel motion';
    }

    /**
     * 
     * @returns boolean true if it's enabled 
     */
    init() {        
        let st = this.app.pmchat.config.site_token;
        this.enabled = 'digitalData' in window
        && ['speeddra2'].includes(st);//Site validation
        if(this.enabled){
            this.addHandlers();        
        }else{
            console.info("PmDrsAdobeDtm not enabled, window.digitalData not available");
        }
        return this.enabled;
    }
    
    fireEvent(eventName, params){        
        if(!this.enabled) return;//skip if not enabled

        const functionName =  `_${eventName}Event`;
        if(typeof this[functionName] === 'function'){
            const dtmEvent = this[functionName](params);
            console.log(dtmEvent)
        }
    }

    _smsChatInitEvent({chatSessionId}) {
        console.info("PmDrsAdobeDtm: smsChatInit");
        var dtmEvent = {
          type: "CustomTagEvent",
          eventName: "sms",
          eventAction: "chat",
          attributes: { provider: this.providerName },
        }
        window.digitalData.chatID = chatSessionId;
        window.digitalData.newEvent(dtmEvent);
        return dtmEvent;
    }

    /**
     * looks like a double for chatInit but they sent two different requirements 
     */
    _smsChatInitiationEvent({chatSessionId}) {//not in use
        console.info("PmDrsAdobeDtm: smsChatInitiation");
        var dtmEvent = {
          type: "CustomTagEvent",
          eventName: "initiation",
          eventAction: "chat",
          attributes: { 
            chatType: 'passive',
            location: 'floating',
            provider: this.providerName 
        },
        }
        window.digitalData.chatID = chatSessionId;
        window.digitalData.newEvent(dtmEvent);
        return dtmEvent;
    }

    _smsChatAcceptedEvent() {//not in use
        console.info("PmDrsAdobeDtm: smsChatAccepted");
        var dtmEvent = {
          type: "CustomTagEvent",
          eventName: "acceptance",
          eventAction: "chat",
          attributes: { 
            provider: this.providerName 
        },
        }
        window.digitalData.newEvent(dtmEvent);
        return dtmEvent;
    }

    _smsChatDeclinedEvent() {//not in use
        console.info("PmDrsAdobeDtm: smsChatDeclined");
        var dtmEvent = {
          type: "CustomTagEvent",
          eventName: "declined",
          eventAction: "chat",
          attributes: { 
            provider: this.providerName 
        },
        }
        window.digitalData.newEvent(dtmEvent);
        return dtmEvent;
    }

    addHandlers() {
        var dataLayer = this;      
        var chatInitiated = false;
        //CHAT CLICK EVENT
        DOMHelper.addHandler(
            this.app.getSelector('.pmcb-open-btn'),
            "click", 
            (event) => {   
                if(chatInitiated) return ;//skip

                let form = document.querySelector(dataLayer.app.getSelector('.pmcb-msg-form'));
                let formData = new FormData(form);  
                let chatLeadId = formData.get("leadId");
                let ftid = formData.get("ftid");

                let args = {chatSessionId: ftid};
                dataLayer.fireEvent('smsChatInit', args);
                chatInitiated = true;
                // dataLayer.fireEvent('smsChatInitiation', args);
            }
        );
    }

}

